<template>
  <div>
    <v-text-field
      outlined
      label="Författare"
      placeholder="Författare"
      v-model="author"
    ></v-text-field>
    <v-select :items="typeArticleOptions" v-model="articleType" label="Typ av artikel" outlined />
  </div>
</template>

<script>
import { defaultPageMetaData } from '@/assets/data/metaData.js'
export default {
  name: 'PartPageHavsutsikt',
  props: {
    page_meta: { type: String, default: '' },
  },
  computed: {
    typeArticleOptions() {
      return ['Artikel', 'Art i fokus', 'Ledare', 'Så funkar det', 'Forskarminnet']
    },
    meta() {
      try {
        if (!this.page_meta) {
          return defaultPageMetaData
        }
        return JSON.parse(this.page_meta)
      } catch (error) {
        return defaultPageMetaData
      }
    },
    author: {
      get() {
        return this.meta.author
      },
      set(val) {
        this.emit({ ...this.meta, author: val })
      },
    },
    articleType: {
      get() {
        return this.meta.articleType
      },
      set(val) {
        this.emit({ ...this.meta, articleType: val })
      },
    },
  },
  methods: {
    emit(payload) {
      this.$emit('update', { page_meta: JSON.stringify(payload) })
    },
  },
}
</script>

<style lang="scss" scoped></style>
